import PropTypes from 'prop-types';
import { useTheme, useMediaQuery } from '@mui/material';
import { Avatar, Button, CardActions, CardContent, Divider, Grid, Typography } from '@mui/material';
import MainCard from '../../layouts/ui-component/cards/MainCard';
import PopularHistory from '../../layouts/ui-component/cards/card-content/PopularHistory';
import { gridSpacing } from '../../constant/Constants';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { IconHistory } from '@tabler/icons';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { formatDate, formatMoney } from '../../utils/function/Function'
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { graphGetAllContractByCustomer } from '../../services/Contract';
import { transactionHistory } from '../../services/Transaction';

// ==============================|| Short Transaction History ||============================== //

const titleButton = { color: Color.Main, cursor: 'default', fontSize: FontSize.Small, fontWeight: 700 };
const cardActionStyle = { p: 1.25, pt: 0, justifyContent: 'center' };
const divide = { my: 1.5 };
const viewButton = {
    color: Color.Main,
    // cursor: 'default',
    fontWeight: 700,
    '&:hover': { background: Color.Button, color: Color.Blur }
};

const ShortTransactionHistory = ({ isLoading, center, contractShortHistory }) => {
    const theme = useTheme();
    var followingDay = new Date(new Date().getTime() - 86400000 * 7);
    const limit = 7;

    const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

    const [contracts, setContracts] = useState(null)
    const [shortHistory, setShortHistory] = useState([]);
    const [fromDate,] = useState(formatDate(followingDay));
    const [toDate,] = useState(formatDate(new Date()));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(openLoadingApi());
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setContracts(result.items);
            dispatch(closeLoadingApi());
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    useEffect(() => {
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        if (contracts !== null) {
            if (contractShortHistory === undefined) {
                const data = {
                    contractId: parseInt(contracts[0].id),
                    fromDate: fromDate,
                    toDate: toDate
                }
                let transactionsHistory = transactionHistory(data);
                transactionsHistory
                    .then(result => {
                        setShortHistory(result.data.TransactionList);
                    }).catch(function (error) {
                        alert = { ...alert, message: error };
                        dispatch(showAlert(alert));
                    })
            }
            else {
                setShortHistory(contractShortHistory);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contractShortHistory, contracts]);

    return (
        <>
            {isLoading ? (
                <PopularHistory />
            ) : (
                <MainCard content={false} sx={{ height: '100%' }}>
                    <CardContent sx={{ height: 'calc(100% - 3rem)' }}>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Grid container alignContent="center" justifyContent="space-between">
                                    <Grid item>
                                        <Button endIcon={<IconHistory />} sx={titleButton}>
                                            Transaction History
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} >
                                {shortHistory
                                    .slice(0, limit)
                                    .map((history, index) => {
                                        return (
                                            <div key={index}>
                                                <Grid container direction="column" sx={{ pl: center ? (matchDownXL ? 0 : 50) : 0, pr: center ? (matchDownXL ? 0 : 50) : 0 }}>
                                                    <Grid item>
                                                        <Grid container alignItems="center" textAlign="left" justifyContent="space-between" sx={{ display: matchDownMD ? 'block' : 'flex' }}>
                                                            <Grid item>
                                                                <Typography variant="subtitle1" >
                                                                    {history.partnerNumber}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Grid container alignItems="center">
                                                                    {history.transAmount < 0 ? (
                                                                        <>
                                                                            <Grid item>
                                                                                <Typography variant="subtitle1" color={Color.Dangerous}>
                                                                                    {formatMoney(history.transAmount.replace(/-/g, " "), ' VND')}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item>
                                                                                <Avatar
                                                                                    variant="rounded"
                                                                                    sx={{
                                                                                        width: 16,
                                                                                        height: 16,
                                                                                        borderRadius: '5px',
                                                                                        backgroundColor: theme.palette.orange.light,
                                                                                        color: theme.palette.orange.dark,
                                                                                        ml: 2
                                                                                    }}
                                                                                >
                                                                                    <KeyboardArrowUpOutlinedIcon fontSize="small" color="inherit" />
                                                                                </Avatar>
                                                                            </Grid>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <Grid item>
                                                                                <Typography variant="subtitle1">
                                                                                    {formatMoney(history.transAmount.replace(/-/g, " "), ' VND')}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item>
                                                                                <Avatar
                                                                                    variant="rounded"
                                                                                    sx={{
                                                                                        width: 16,
                                                                                        height: 16,
                                                                                        borderRadius: '5px',
                                                                                        backgroundColor: theme.palette.success.light,
                                                                                        color: theme.palette.success.dark,
                                                                                        ml: 2
                                                                                    }}
                                                                                >
                                                                                    <KeyboardArrowDownOutlinedIcon fontSize="small" color="inherit" />
                                                                                </Avatar>
                                                                            </Grid>
                                                                        </>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item>
                                                        <Grid container alignItems="center" textAlign="left" justifyContent="space-between" sx={{ display: matchDownMD ? 'block' : 'flex' }}>
                                                            <Grid item>
                                                                <Typography variant="subtitle2">
                                                                    {history.transDetails}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Typography variant="subtitle2">
                                                                    {history.transDate.replace(/T/g, " ")}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Divider sx={divide} />
                                            </div>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions sx={cardActionStyle}>
                        <Button href='/transaction/history' endIcon={<ChevronRightOutlinedIcon />} sx={viewButton} size="small" disableElevation >
                            View All
                        </Button>
                    </CardActions>
                </MainCard>
            )}
        </>
    );
};

ShortTransactionHistory.propTypes = {
    isLoading: PropTypes.bool,
};

export default ShortTransactionHistory;
